import { PageTemplate } from '@/shared/ui/templates';
import styles from './index.module.sass';
import { ContractDetailsTop } from '../../components/contract-details-top';
import { ContractDetailsWrap } from '../../components/contract-details-wrap';
import { useEffect, useState } from 'react';
import {
  $specificTradeOffersGroup,
  fetchSpecificTradeOffersGroupDataFx,
} from '../../store/specific-trade.store';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useStore } from 'effector-react';
import { ButtonMain } from '@/modules/common/components/button';
import { numberToReadable } from '@/modules/common/helpers/number-to-readable.helper';
import { Button, notification } from 'antd';
import { $agricultureById } from '@/modules/agriculture/store/agriculture.store';
import { finishOrdersListFx } from '../../store/business-offers.store';
import { filterExpiredOffers } from '../../functions/filter-expired-ofers';
import { WITHOUT_VAT } from '@/shared/constants/price.constants';

export const ContractDetailsPage = () => {
  const { id } = useParams();
  const [params] = useSearchParams();
  const data = useStore($specificTradeOffersGroup);
  const offers = filterExpiredOffers(data?.offers);
  const offersIds = offers?.map((item) => item.id);
  const [modalStatus, setModalStatus] = useState({ display: false, step: 1 });
  const [loading, setLoading] = useState(false);
  const agricultures = useStore($agricultureById);

  const navigate = useNavigate();

  useEffect(() => {
    if (id && params) {
      const buyerable_id = Number(params.get('buyerable_id'));
      const buyerable_type = String(params.get('buyerable_type'));
      buyerable_id &&
        buyerable_type &&
        fetchSpecificTradeOffersGroupDataFx({ buyerable_id, buyerable_type });
    }
  }, [id, params]);
  return (
    <PageTemplate
      header={
        data?.buyer.name
          ? `оформленные сделки - ${data?.buyer.name}`
          : `оформленные сделки`
      }
      customBack="/offer/contracts"
      mainClassName={styles.customMain}
    >
      <div className={styles.root}>
        <ContractDetailsTop setModalStatus={setModalStatus} />
        <ContractDetailsWrap />
      </div>
      {modalStatus.display && (
        <div className={styles.finishModal}>
          <div className={styles.content}>
            {modalStatus.step === 1 ? (
              <div className={styles.firstStep}>
                <h4>ВАЖНО</h4>
                <p>
                  После нажатия на кнопку "Завершить сделку", Ваш склад зерновой
                  культуры, будет опустошен на массу отгружаемой в рамках этой сделки
                  зернокультуры.
                </p>
                <p>
                  Данная операция является необратимой, если Вы не уверены, в параметрах
                  осуществляемой отгрузки и в целом в деталях сделки - проcим заранее
                  еще раз уточнить все необходимые параметры сделки и только после
                  этого, нажимать кнопку "Завершить сделку".
                </p>
                <div className={styles.actions}>
                  <Button onClick={() => setModalStatus({ display: false, step: 1 })}>
                    вернуться
                  </Button>
                  <Button
                    type="primary"
                    loading={loading}
                    onClick={async () => {
                      setLoading(true);
                      // try {
                      //   await finishOrdersListFx(offersIds as number[]);
                      // } catch (err: any) {
                      //   if (err.error) return notification.warning({ message: err.error });
                      //   notification.warning({ message: 'Непредвиденная ошибка. Попробуйте, пожалуйста, позже.' });
                      //   setModalStatus({ display: true, step: 1 });
                      //   setLoading(false);
                      //   return;
                      // }
                      setLoading(false);
                      setModalStatus({ display: true, step: 2 });
                    }}
                  >
                    подтверждаю
                  </Button>
                </div>
              </div>
            ) : (
              <div className={styles.secondStep}>
                <h4>Сделка завершена</h4>
                <p>
                  Вы завершили сделку с <b>{data?.buyer.name}</b> по продаже
                  зернокультуры{' '}
                  <b>
                    "{agricultures[data?.offers[0]?.agriculture_ids[0] as number].name}"
                  </b>
                  .
                </p>
                <div className={styles.metrics}>
                  <span>
                    общая сумма сделки {WITHOUT_VAT}:{' '}
                    <b>
                      {numberToReadable(
                        Number(
                          offers?.reduce((acc, curr) => acc + +curr?.price_all, 0) || 0,
                        ),
                      )}{' '}
                      ₽
                    </b>
                  </span>
                  <span>
                    масса проданной зернокультуры:{' '}
                    <b>
                      {numberToReadable(
                        Number(
                          offers?.reduce(
                            (acc, curr) =>
                              acc + (+curr?.weight + +curr.weight_gain_tons),
                            0,
                          ) || 0,
                        ),
                        2,
                      )}{' '}
                      т
                    </b>
                  </span>
                  <span>
                    общая стоимость логистики:{' '}
                    <b>
                      {numberToReadable(
                        Number(
                          offers?.reduce(
                            (acc, curr) => acc + +curr?.price_logistic,
                            0,
                          ) || 0,
                        ),
                      )}{' '}
                      ₽
                    </b>
                  </span>
                  <span>
                    склады к отгрузке:{' '}
                    <b>
                      {Array.from(
                        new Set(offers?.map((item) => item.warehouse_name)),
                      ).join(', ')}
                    </b>
                  </span>
                </div>
                <p>
                  О чем, Вам и Вашему контрагенту <b>{data?.buyer.name}</b>, на почтовый
                  адрес, указанный при регистрации поступит соответствующее почтовое
                  сообщение с описанием деталей сделки.
                </p>
                <p>Спасибо, за то, что в своей работе, используете нашу систему!</p>
                <div className={styles.actions}>
                  <Button
                    onClick={() => {
                      setModalStatus({ display: false, step: 1 });
                      navigate('/offer/contracts');
                    }}
                  >
                    вернуться
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </PageTemplate>
  );
};
